import { meta as stackMeta } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/StackBlock/StackBlockMetaData";

import type { ComponentMeta } from "@/react/components/shared/BuilderUI/BuilderUI.types";

export const meta: ComponentMeta = {
  ...stackMeta,
};
